import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "button" ]

  connect() {
    const select = this.element.querySelector("select")
    select.addEventListener("change", () => {
      this.updateButton()
    })
  }

  updateButton() {
    const select = this.element.querySelector("select")
    this.buttonTargets.forEach((button) => {
      if (button.dataset.value == select.value) {
        button.classList.add(`btn-highlight-${select.value}--selected`)
      } else {
        button.classList.remove(`btn-highlight-${button.dataset.value}--selected`)
      }
    })
  }

  select(event) {
    const select = this.element.querySelector("select")
    select.value = event.target.dataset.value
    this.updateButton()
  }
}